/**
 * WordPress dependencies
 */
import { createSlotFill } from '@wordpress/components';

var _createSlotFill = createSlotFill('__experimentalBlockSettingsMenuPluginsExtension'),
    __experimentalBlockSettingsMenuPluginsExtension = _createSlotFill.Fill,
    Slot = _createSlotFill.Slot;

__experimentalBlockSettingsMenuPluginsExtension.Slot = Slot;
export default __experimentalBlockSettingsMenuPluginsExtension;
//# sourceMappingURL=block-settings-menu-plugins-extension.js.map